export default {"src":"/_next/static/media/treyd_square_logo_black.4c77fdac.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};